// extracted by mini-css-extract-plugin
module.exports = {"ms":"(min-width: 20rem)","sm":"(min-width: 30rem)","md":"(min-width: 48rem)","lg":"(min-width: 64rem)","xlg":"(min-width: 75rem)","xxlg":"(min-width: 120rem)"};